var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 73.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 776 l0 -226 -25 0 c-23 0 -25 -3 -25 -50 0 -47 2 -50 25 -50 21 0 25 -5 25 -30 0 -25 -4 -30 -25 -30 -23 0 -25 -3 -25 -50 0 -47 2 -50 25 -50 l25 0 0 -145 0 -145 50 0 50 0 0 145 0 145 190 0 190 0 0 50 0 50 -190 0 -190 0 0 30 0 30 168 0 c92 0 184 5 204 10 59 17 130 71 163 124 40 65 48 179 18 247 -28 63 -68 106 -127 137 -51 27 -53 27 -288 30 l-238 3 0 -225z m477 103 c66 -32 88 -70 88 -154 0 -84 -22 -122 -88 -154 -39 -19 -61 -21 -210 -21 l-167 0 0 175 0 175 167 0 c149 0 171 -2 210 -21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuble);
export default __webpack_public_path__ + "static/media/ruble.2460332de1dd575561c51eb60dce3234.svg";
export { ForwardRef as ReactComponent };